export type SortBy = 'ASC' | 'DESC'
export enum SORT_BY {
  ASC = 'ASC',
  DESC = 'DESC',
}
